const paginationDisableStyle = (theme, style) => {
  return {
    ...style,
    '.Mui-disabled': {
      opacity: 1,
      color: theme.tokens.ComponentPaginationDisabledColor
    }
  };
};
const paginationDefaultStyle = theme => {
  return {
    '.MuiPaginationItem-root.Mui-selected': {
      backgroundColor: theme.tokens.ComponentPaginationSelectedBg,
      borderRadius: 0,
      borderColor: theme.tokens.ComponentPaginationSelectedColor,
      color: theme.tokens.ComponentPaginationSelectedColor,
      '&:after': {
        display: 'block',
        position: 'absolute',
        left: 0,
        bottom: 0,
        color: 'transparent',
        content: `"."`,
        backgroundColor: theme.tokens.ComponentPaginationSelectedColor,
        width: '100%',
        height: '4px'
      },
      '&:hover': {
        backgroundColor: 'transparent'
      }
    },
    '.MuiPaginationItem-root': {
      color: theme.tokens.ComponentPaginationColor,
      fontSize: theme.tokens.ComponentPaginationFontSize,
      height: '40px',
      minWidth: '40px',
      padding: 0,
      margin: '0 2px',
      fontWeight: 500,
      '&:hover': {
        backgroundColor: theme.tokens.ComponentPaginationHoverBackgroundColor,
        borderRadius: 0
      },
      '&:active': {
        backgroundColor: theme.tokens.ComponentPaginationHoverBackgroundColor,
        borderRadius: 0
      }
    },
    '.MuiPaginationItem-ellipsis': {
      display: 'none'
    },
    '.MuiPaginationItem-icon': {
      fontSize: '16px'
    }
  };
};
const paginationStyleBuilder = theme => {
  let style = paginationDefaultStyle(theme);
  style = paginationDisableStyle(theme, style);
  return style;
};
export default paginationStyleBuilder;